import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'ngcNotAssigned'
})
export class NotAssignedPipe implements PipeTransform {

    static getSanitizedNullValue(data: any, allowNull: boolean = false): any {
        if (!data || (!allowNull && ((data === 'null') || (data === 'NULL')))
            || (Array.isArray(data) && ((data.length === 0) || ((data.length === 1) && (!data[0] || ((data[0] === 'null') || (data[0] === 'NULL'))))))
        ) {
            return '';
        }
        return data;
    }

    static getSanitizedNullValuesObj(obj: any, allowNull: boolean = false): any {
        if (obj) {
            Object.keys(obj)
                .forEach((key: string) =>
                    obj[key] = NotAssignedPipe.getSanitizedNullValue(obj[key], allowNull)
                );
        }
        return obj;
    }

    transform(data: any, sanitizeNullValue: boolean = false, allowNull: boolean = false): string {
        data = (sanitizeNullValue ? NotAssignedPipe.getSanitizedNullValue(data, allowNull) : data);
        return data ? data : 'n/a';
    }
}
